import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useIsMobile } from 'hooks/useIsMobile'
import ModalPortal from 'components/Modal'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import { encodeStorage, removeStorage } from 'functions/storageBase64'
import { dataLayerButtons } from 'functions/dataLayerFunction'
import { VARIANTS_PER_PORTAL } from 'constants/general'

export function PagarPlan(props){
    const {
        cardending,
        typeButton,
        saldoPay
    } = props

    const { isMobile } = useIsMobile()
    const history = useHistory()

    
    const [showModalPagarTarjeta, SetShowModalPagarTarjeta] = useState(false);
    const handleClose = () => SetShowModalPagarTarjeta(false);


    removeStorage('cardendingPayment')
    removeStorage('noInternetPayment')

    const handlePagarTarjeta = () => {
        // if(VARIANTS_PER_PORTAL?.pagoRef){
        //     SetShowModalPagarTarjeta(true);
        // }else{
        //     handleTarjetaCredito()
        // }
        handleTarjetaCredito()
    };


    const handleTarjetaCredito = () => {
        encodeStorage('cardendingPayment', cardending)
        dataLayerButtons({eventName: "credito_pagar"})
        history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar-tarjeta`);
    };

    const handleReferenciado = () => {
        dataLayerButtons({eventName: "credito_pagar"})
        history.push(`${BASE_PATH}${SUB_DIRECTORY}referenciado`);
    };

    const [pagar, setPagar] = useState(true)
    useEffect(()=>{
        if(Number(saldoPay) >= 1 ){
            setPagar(true)
        }else{
            setPagar(false)
        }
    },[saldoPay])

    return(
        <>
            {isMobile
                ? isMobile === 'desktop'
                    ?
                        pagar
                            ?
                                <div className="boxBtnPagarDsk">
                                    <button onClick={handlePagarTarjeta}>Pagar Tarjeta</button>
                                </div>
                            : <p className="textPago">Actualmente no cuentas con saldo pendiente</p>
                    :
                        typeButton === "inline"
                            ?
                                <button className="btnOpcT borderLeftOpc" onClick={handlePagarTarjeta}>Pagar</button>
                            :
                                pagar
                                    ?
                                        <div className="boxButtonPagar">
                                            <button onClick={handlePagarTarjeta} className="btnPagar">Pagar Tarjeta</button>
                                        </div>
                                    : <p className="textPago">Actualmente no cuentas con saldo pendiente</p>
                : null
            }
            {showModalPagarTarjeta &&
                <ModalPortal type="modal payCard" onClose={handleClose} >
                    <div className="modalCardPay">
                        <div className="contBtnsEnterado">
                            <div className="contBtns">
                                <div className="btn rojo" onClick={handleTarjetaCredito}>Pagar con tarjeta bancaria</div>
                                <div className="btn blanco" onClick={handleReferenciado}>Pago referenciado</div>
                            </div>
                        </div>
                    </div>
                </ModalPortal>
            }
        </>
    )
}